// Antd v5 theme tokens for the admin panel.
//
// Ported from the legacy `src/theme.js` Less variable map. The two apps share
// most colors but the admin tweaks input backgrounds, label color, and table
// hover behavior, so they keep separate theme files.

const PRIMARY = '#7BAD7E';
const TEXT = '#7C7C7C';
const HEADING = '#848C94';
const BORDER = '#E1E6ED';
const LAYOUT_BG = '#F4F4F4';
const COMPONENT_BG = '#F4F4F4';
const INPUT_BG = '#FFFFFF';

export const antdTheme = {
  token: {
    colorPrimary: PRIMARY,
    colorLink: PRIMARY,
    colorLinkHover: '#6a9a6d',
    colorLinkActive: '#5a8a5d',
    colorSuccess: '#36b639',
    colorError: '#eb0404',
    colorBgLayout: LAYOUT_BG,
    colorBgContainer: COMPONENT_BG,
    colorText: TEXT,
    colorTextHeading: HEADING,
    colorBorder: BORDER,
    colorBorderSecondary: BORDER,
    colorSplit: COMPONENT_BG,
    borderRadius: 4,
    fontFamily:
      "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Helvetica, sans-serif",
  },
  components: {
    Layout: {
      bodyBg: LAYOUT_BG,
      headerBg: '#FFFFFF',
      siderBg: '#FFFFFF',
    },
    Table: {
      headerBg: COMPONENT_BG,
      headerColor: HEADING,
      rowHoverBg: '#ececec',
      cellPaddingBlock: 16,
      cellPaddingInline: 16,
    },
    Menu: {
      itemColor: TEXT,
      itemSelectedColor: PRIMARY,
      itemHoverBg: COMPONENT_BG,
      itemSelectedBg: COMPONENT_BG,
      itemActiveBg: COMPONENT_BG,
    },
    Tabs: {
      inkBarColor: PRIMARY,
      itemSelectedColor: PRIMARY,
      itemHoverColor: PRIMARY,
      itemActiveColor: PRIMARY,
    },
    Button: {
      colorPrimary: PRIMARY,
      primaryColor: '#FFFFFF',
      defaultBg: COMPONENT_BG,
      defaultBorderColor: '#C7CBCE',
    },
    Radio: {
      buttonCheckedBg: PRIMARY,
      buttonSolidCheckedColor: '#FFFFFF',
      colorPrimary: PRIMARY,
    },
    Input: {
      hoverBorderColor: PRIMARY,
      activeBorderColor: PRIMARY,
      colorTextPlaceholder: '#AFAFAF',
      colorBgContainer: INPUT_BG,
    },
    Select: {
      colorBgContainer: INPUT_BG,
      optionSelectedFontWeight: 600,
      optionSelectedBg: PRIMARY,
      optionSelectedColor: '#1A1A1A',
    },
    Modal: {
      headerBg: '#FFFFFF',
      contentBg: '#FFFFFF',
    },
    Tag: {
      defaultBg: PRIMARY,
      defaultColor: '#FFFFFF',
    },
    Switch: {
      colorPrimary: PRIMARY,
    },
    Pagination: {
      itemActiveBg: 'transparent',
    },
  },
};
